import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import {AppSettings} from '../../app-settings';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-locked-activity-popup',
  templateUrl: './locked-activity-popup.component.html',
  styleUrls: ['./locked-activity-popup.component.css'],
    animations:[trigger('coursePopUpInOut', [
    transition(':enter', [
          style({opacity: 0}),
          animate('0.3s', style({opacity: 1}))
        ]),
    transition(':leave', [
          style({opacity: 1}),
          animate('0.3s', style({opacity: 0}))
        ])
    ]
    )]
})
export class LockedActivityPopupComponent implements OnInit {

  @Output() onPopUpFlagChange = new EventEmitter<boolean>();
  @Input() _lockActivityData: any;

  popLockeImg = AppSettings.cdnUrl + "assets/images/course_locked.gif";
  closePopCourse = AppSettings.cdnUrl + "assets/images/closePopcourse.png";
  // upgradeURL = AppSettings.restApiUrl + '/api/package/upgrade';
  pricingPageRoute = AppSettings.publicSiteURL + '/pricing?scroll=scroll-to-buy-now';

  constructor() {

   }

  ngOnInit() {
    console.log(this._lockActivityData);
  }

  closeCoursePopUpEvent()
  {
    this._lockActivityData["coursePopUpFlag"] = false;
  	//this.onPopUpFlagChange.emit(false);
  	document.body.classList.remove('coursePopIn');
  }
}
